import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { IconWrapper } from "../../Components/StyledComponents/StyledComponents";
import environmentVariables from "../../config/environmentVariables";

const PoolIcon = `${environmentVariables?.cdnUrl}poolIcon.png`;
const Root = styled.div`
  margin-top: ${(p) => p.theme.spacing.xl};
  @media (max-width: ${(p) => p.theme.screen.sm}) {
    margin-top: ${(p) => p.theme.spacing.none};
  }
`;

const Container = styled.div`
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  @media (max-width: ${(p) => p.theme.screen.md}) {
    width: 90%;
  }
  @media (max-width: ${(p) => p.theme.screen.sm}) {
    width: 100%;
    padding: ${(p) => p.theme.spacing.sm} ${(p) => p.theme.spacing.sm}
      ${(p) => p.theme.spacing.none} ${(p) => p.theme.spacing.sm};
  }
`;
const Heading = styled.div`
  font-family: ${(p) => p.theme.font.family.SweraDemo};
  color: #e3e3e3;
  font-size: 24px;
  font-weight: ${(p) => p.theme.font.weight.bolder};
  display: flex;
  align-items: center;
`;

const CardWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: ${(p) => p.theme.spacing.sm} 0;
  display: flex;
  @media (max-width: ${(p) => p.theme.screen.xs}) {
    flex-direction: column;
    margin: 0 0;
  }
`;

const Card = styled.div`
  width: calc(50% - 20px);
  background-color: #262a2d;
  border-radius: ${(p) => p.theme.radius.lg};
  padding: ${(p) => p.theme.spacing.md};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  @media (max-width: ${(p) => p.theme.screen.xs}) {
    width: 100%;
    margin-top: ${(p) => p.theme.spacing.sm};
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${(p) => p.theme.spacing.md} ${(p) => p.theme.spacing.sm};
  }
`;

const Title = styled.div`
  font-size: ${(p) => p.theme.font.size.lg};
  font-weight: ${(p) => p.theme.font.weight.bolder};
  font-family: ${(p) => p.theme.font.family.SweraDemo};
  margin-bottom: ${(p) => p.theme.spacing.xs};
  @media (min-width: 1600px) {
    font-size: ${(p) => p.theme.font.size.xl};
  }
  @media (max-width: ${(p) => p.theme.screen.sm}) {
    font-size: ${(p) => p.theme.font.size.lg};
    font-weight: ${(p) => p.theme.font.weight.bold};
  }
  @media (max-width: ${(p) => p.theme.screen.xxs}) {
    font-size: ${(p) => p.theme.font.size.md};
  }
`;
const Button = styled.button`
  padding: ${(p) => p.theme.newspacing.xs} ${(p) => p.theme.spacing.md};
  border-radius: ${(p) => p.theme.spacing.xl};
  font-size: ${(p) => p.theme.font.size.sm};
  font-weight: ${(p) => p.theme.font.weight.bold};
  border: none;
  background-color: ${(p) => p.theme.colors.white};
  cursor: pointer;

  @media (max-width: ${(p) => p.theme.screen.sm}) {
    padding: ${(p) => p.theme.spacing.xs} ${(p) => p.theme.spacing.sm};
    font-size: ${(p) => p.theme.font.size.xs};
  }
  @media (min-width: 1600px) {
    font-size: ${(p) => p.theme.font.size.md};
    padding: ${(p) => p.theme.newspacing.xs} ${(p) => p.theme.spacing.md};
  }
  @media (min-width: 1800px) {
    font-size: ${(p) => p.theme.font.size.md};
    padding: ${(p) => p.theme.newspacing.sm} ${(p) => p.theme.spacing.lg};
  }
`;

const Icon = styled.img`
  width: 26px;
  height: 26px;
  aspect-ratio: auto 1/1;
`;

const MetaPoolSection = () => {
  let navigate = useNavigate();
  return (
    <Root>
      <Container>
        <Heading>
          <IconWrapper>
            <Icon src={PoolIcon} />
          </IconWrapper>{" "}
          Meta Market
        </Heading>
        <CardWrapper>
          <Card>
            <Title>POOL</Title>
            <Button
              onClick={() => {
                navigate("/pool");
              }}
            >
              Enter Pool
            </Button>
          </Card>
          <Card>
            <Title>Stake</Title>
            <Button
              onClick={() => {
                navigate("/stake");
              }}
            >
              Enter Stake
            </Button>
          </Card>
        </CardWrapper>
      </Container>
    </Root>
  );
};

export default MetaPoolSection;
